export * from "./status-transaction.directive";



// WEBPACK FOOTER //
// /app/src/app/directives/status-transaction/index.ts